<template>
  <div class="nav">
    <img @click="gotohome" src="@/assets/mobile/logo.png" alt="" />
    <img @click="showPopup" src="@/assets/mobile/icon.png" alt="" />
    <van-popup
      v-model="show"
      position="right"
      closeable
      close-icon-position="top-right"
      :style="{ height: '100vh', width: '77%' }"
    >
      <div class="navList">
        <div
          :class="item.id == navIndex ? 'select' : ''"
          v-for="(item, i) in navList"
          :key="i"
          @click="select(item)"
        >
          {{ item.title }}
          <img
            class="right"
            v-if="item.name == 'app' || item.name == 'product'"
            src="../../assets/mobile/right.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="isApp"
      position="right"
      closeable
      close-icon-position="top-right"
      :style="{ height: '100vh', width: '77%' }"
    >
      <div class="navList">
        <div
          style="display: flex; flex-direction: column; align-items: center; padding: 0"
        >
          <img
            class="logo_img"
            style="width: 200px; height: 200px"
            src="@/assets/pc/pcHeader/panda_QR.png"
            alt=""
          />
          <div style="padding: 0">微信扫一扫</div>
        </div>
        <!-- <div
          :class="item.id == appIndex ? 'select' : ''"
          v-for="(item, i) in appList"
          :key="i"
          @click="open(item)"
        >
          <img class="logo_img" :src="item.img" alt="" />
          {{ item.title }}
        </div> -->
      </div>
    </van-popup>
    <van-popup
      v-model="isWebsite"
      position="right"
      closeable
      close-icon-position="top-right"
      :style="{ height: '100vh', width: '77%' }"
    >
      <div class="navList">
        <div
          :class="item.id == websiteIndex ? 'select' : ''"
          v-for="(item, i) in websiteList"
          :key="i"
          @click="open2(item)"
        >
          <img class="logo_img" :src="item.img" alt="" />
          {{ item.title }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      isApp: false,
      isWebsite: false,
      navIndex: 1,
      navList: [
        { id: 1, title: "首页", name: "mobileHome" },
        { id: 2, title: "公司动态", name: "mobileNews" },
        // { id: 3, title: '日语高考', name: 'mobileGaokao' },
        // { id: 4, title: '聚趣网校', name: 'product' },
        { id: 5, title: "联系我们", name: "mobileContact" },
        // { id: 6, title: '下载APP', name: 'app' },
        { id: 6, title: "熊猫云学堂", name: "app" },
      ],
      appIndex: 0,
      websiteIndex: 0,
      appList: [
        {
          id: 1,
          title: "日语GO",
          name: "japanese",
          img: require("@/assets/mobile/japanese.png"),
          url: "https://api.juquedu.com/website/index.html",
        },
        {
          id: 2,
          title: "德语GO",
          name: "german",
          img: require("@/assets/mobile/german.png"),
          url: "https://german.juquedu.com/website/index.html",
        },
        {
          id: 3,
          title: "法语GO",
          name: "french",
          img: require("@/assets/mobile/french.png"),
          url: "https://fr.juquedu.com/website/index.html",
        },
      ],
      websiteList: [
        {
          id: 1,
          title: "德语",
          name: "german",
          img: require("@/assets/mobile/german.png"),
          url: "https://german.juquedu.com/school/index.html",
        },
        {
          id: 2,
          title: "法语",
          name: "french",
          img: require("@/assets/mobile/french.png"),
          url: "https://fr.juquedu.com/school/index.html",
        },
      ],
    };
  },

  methods: {
    showPopup() {
      this.show = true;
    },
    select(item) {
      console.log(item);
      if (item.name != "app") {
        if (item.name == "product") {
          this.isWebsite = true;
          if (this.$route.path != "/mobileHome") {
            this.gotohome();
          }
        } else {
          this.show = false;
          sessionStorage.navIndex = item.id;
          this.$router.push({ name: item.name });
          this.navIndex = sessionStorage.navIndex;
        }
      } else {
        this.isApp = true;
        console.log(this.$route.path);
        if (this.$route.path != "/mobileHome") {
          this.gotohome();
        }
      }
    },
    open(item) {
      window.open(item.url);
      sessionStorage.appIndex = item.id;
      this.appIndex = sessionStorage.appIndex;
    },
    open2(item) {
      window.open(item.url);
      sessionStorage.websiteIndex = item.id;
      this.websiteIndex = sessionStorage.websiteIndex;
    },
    gotohome() {
      this.$router.push("/mobileHome");
      sessionStorage.navIndex = 1;
      this.navIndex = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  background: #fff;
  position: sticky;
  top: 0;
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  z-index: 999;
  border-bottom: solid 1px #e8e8e8;
  img {
    width: 48px;
    height: 48px;
  }
  .navList {
    margin-top: 92px;
    line-height: 72px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    div {
      // padding-left: 59px;
      height: 72x;
      border-bottom: 1px solid #ebedef;
      display: flex;
      align-items: center;
      padding-left: 40px;
      box-sizing: border-box;
      .right {
        width: 9px;
        height: 16px;
        margin-left: 117px;
      }
      .logo_img {
        width: 25px;
        height: 25px;
        margin-right: 10px;
      }
    }
    // div:active {
    // 	background: #e8e8e8;
    // }
    .select {
      background-color: #e8e8e8;
      // padding-left: 19px;
    }
  }
}
/deep/ .van-popup__close-icon {
  color: #121212;
}
</style>
